export default __webpack_public_path__ + "static/icon-background-3723861702c4223007ae63460d4cfd0c.png";